import { get, getFile, post } from '../api';

const endpoints = {
  lowerReserveReferred: `${window.envConfig.SELLERS_API_BASE_URL}actions/negotiable/lowerreserve`,
  lowerReserveAuction: `${window.envConfig.SELLERS_API_BASE_URL}actions/auction/updatereserve`,
  holdReserve: `${window.envConfig.SELLERS_API_BASE_URL}actions/negotiable/holdreserve`,
  acceptBid: `${window.envConfig.SELLERS_API_BASE_URL}actions/negotiable/acceptbid`,
  viewPaymentDetails: `${window.envConfig.SELLERS_API_BASE_URL}actions/payment/details`,
  accountSaleInvoice: `${window.envConfig.SELLERS_API_BASE_URL}actions/payment/AccountSaleInvoice`,
};

export type LowerReserveRequestType = {
  LotSku: string;
  NewReservePrice: number;
};

export type ReserveReturnType = boolean;

export const lowerReserveReferred = async (
  token: string,
  request: LowerReserveRequestType
): Promise<ReserveReturnType> => {
  const results = await post<ReserveReturnType>({
    url: endpoints.lowerReserveReferred,
    body: request as any,
    token,
  });
  return results;
};

export const lowerReserveAuction = async (
  token: string,
  request: LowerReserveRequestType
): Promise<ReserveReturnType> => {
  const results = await post<ReserveReturnType>({
    url: endpoints.lowerReserveAuction,
    body: request as any,
    token,
  });
  return results;
};

export type HoldReserveRequestType = {
  LotSku: string;
};

export const holdReserve = async (
  token: string,
  request: HoldReserveRequestType
): Promise<ReserveReturnType> => {
  const results = await post<ReserveReturnType>({
    url: endpoints.holdReserve,
    body: request as any,
    token,
  });
  return results;
};

export type AcceptBidRequestType = {
  LotSku: string;
};

export const acceptBid = async (
  token: string,
  request: AcceptBidRequestType
): Promise<ReserveReturnType> => {
  const results = await post<ReserveReturnType>({
    url: endpoints.acceptBid,
    body: request as any,
    token,
  });
  return results;
};

export type ViewPaymentDetailsRequestType = {
  LotSku: string;
};

export type InvoiceParams = {
  saleNo: string | number;
  vendorNo: string | number;
  managingOfficeId: string | number;
};

export type ViewPaymentDetailsReturnType = {
  paymentDate: string;
  details: string;
  quantity: string;
  amount: string;
  invoiceParams: InvoiceParams | null;
};

export const viewPaymentDetails = async (
  token: string,
  urlParams: ViewPaymentDetailsRequestType
): Promise<ViewPaymentDetailsReturnType[]> => {
  const results = await get<ViewPaymentDetailsReturnType[]>({
    url: endpoints.viewPaymentDetails,
    urlParams,
    token,
  });
  return results;
};

export type GetAccountSaleInvoiceRequestType = {
  saleNo: string;
  vendorNo: string;
  managingOfficeId: string;
};

export const getAccountSaleInvoice = async (
  token: string,
  urlParams: GetAccountSaleInvoiceRequestType
): Promise<any> => {
  await getFile({
    url: endpoints.accountSaleInvoice,
    urlParams,
    token,
  });
};
